// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.PortalModalHeader_header__yyUyx {
  background-color: #333;
  display: flex;
  height: 4rem;
  align-items: center;
}

.PortalModalHeader_title__qvTGF {
  flex: 1 1;
  color: white;
  margin-left: 1rem;
  font-size: 1.6rem;
}

.PortalModalHeader_close-button__m3xIM {
  width: 4rem;
  height: 4rem;
  background-color: #333;
}
.PortalModalHeader_close-button__m3xIM:hover {
  background-color: #222;
}
.PortalModalHeader_close-button__m3xIM:active {
  background-color: #000;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/PortalModal/PortalModalHeader.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,sBDiBU;EChBV,aAAA;EACA,YAAA;EACA,mBAAA;AAeF;;AAZA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAeF;;AAZA;EACE,WAAA;EACA,YAAA;EACA,sBDCU;ACcZ;AAbE;EACE,sBAAA;AAeJ;AAbE;EACE,sBAAA;AAeJ","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.header {\n  background-color: #333;\n  display: flex;\n  height: 4rem;\n  align-items: center;\n}\n\n.title {\n  flex: 1;\n  color: white;\n  margin-left: 1rem;\n  font-size: 1.6rem;\n}\n\n.close-button {\n  width: 4rem;\n  height: 4rem;\n  background-color: #333;\n}\n.close-button:hover {\n  background-color: #222;\n}\n.close-button:active {\n  background-color: #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `PortalModalHeader_header__yyUyx`,
	"title": `PortalModalHeader_title__qvTGF`,
	"close-button": `PortalModalHeader_close-button__m3xIM`
};
export default ___CSS_LOADER_EXPORT___;
